import React from 'react';
import { Card } from 'react-bootstrap';
import ModeComponent from '../../ModeComponent';

export default class StartWork extends ModeComponent {
  // properties set on each mount
  clockType = 'employees';
  defaultFocus = 'processButton';
  mode = 'SW';

  schema = {};

  state = {};
  // end properties reset on each mount

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <div style={{ fontSize: '16px', textAlign: 'center' }}>
            Press Process button or Enter key to log start work.
          </div>
        </Card.Body>
      </Card>
    );
  }
}
